import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import $ from 'jquery';
import axios from 'axios';

axios.defaults.timeout = 10000;
axios.defaults.baseURL = 'https://www.beawan.com/';

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
